import {getConfigItem, configConstants} from '@servicenow/ui-config';

const {DISABLE_REST_BATCHING} = configConstants;
export default function isBatchingEnabled() {
	if (typeof getConfigItem(DISABLE_REST_BATCHING) === 'boolean')
		return !getConfigItem(DISABLE_REST_BATCHING);

	return true;
}
